$(function() {

    'use strict';

    /* Sortable tables */

    var sortableTables = $('.table-sortable');

    if (sortableTables.length > 0) {

        sortableTables.children('tbody').sortable({
            axis: 'y',
            cursor: 'ns-resize',
            handle: '.table-sortable-handle',
            helper: function (e, ui) {

                ui.children().each(function () {
                    $(this).width($(this).width());
                });

                return ui;

            },
            update: function (e, ui) {

                var item = ui.item,
                    table = item.closest('table'),
                    url;

                if (item.data('id') === undefined || table.data('sortable-target') === undefined) {
                    return;
                }

                url = table.data('sortable-target');

                $.post(url, {sorted_id: item.data('id'), index: item.index()})
                    .done(function () {
                        item.effect('highlight', {color: '#5cb85c'}, 1000);
                    })
                    .fail(function () {
                        item.effect('highlight', {color: '#d9534f'}, 1000);
                    });

            }
        });

    }

});